import environment from './environment';

const waitForPage = () => {
  return new Promise<void>((resolve) => {
    if (
      document.readyState === 'complete' ||
      document.readyState === 'loading' ||
      document.readyState === 'interactive'
    ) {
      resolve();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        resolve();
      });
    }
  });
};

const createChatParent = (id: string) => {
  let chatParent = document.getElementById(id);

  if (!chatParent) {
    chatParent = document.createElement('div');
    chatParent.setAttribute('id', id);

    // to make sure the widget doesn't get overlapped
    chatParent.style.zIndex = '2147483645';
    chatParent.style.position = 'relative';

    document.getElementsByTagName('body')[0].appendChild(chatParent);
  }

  return chatParent;
};

const generateIframeHTML = () => {
  const page = [
    '<html>',
    '<head>',
    `<title>Chat Widget</title>`,
    '<body style="margin: 0; padding: 0; border: 0">',
    '<div id="simplr-chat-root"></div>',
    '</body>',
    '</html>',
  ].filter(Boolean);

  return page.join('');
};

const renderIframe = () => {
  const iframe = document.createElement('iframe');
  iframe.style.borderWidth = '0';
  iframe.style.borderColor = 'transparent';

  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.visibility = 'hidden';

  iframe.id = 'simplr-chat-iframe';

  // Added to pass automated tests, screen reader really reads the <title> tag in the iframe
  iframe.title = 'Chat Widget';

  const chatParent = createChatParent('simplr-chat-wrapper');
  chatParent.appendChild(iframe);

  const iframeDocument = iframe.contentWindow?.document;

  if (iframeDocument) {
    iframeDocument.open();
    iframeDocument.write(generateIframeHTML());
    iframeDocument.close();

    // csp fix: loading app.js via non parser-inserted element
    // refer: https://content-security-policy.com/strict-dynamic/
    const s = iframeDocument.createElement('script');
    s.src = `${environment.publicUrl}/app.js`;
    s.defer = true;
    iframeDocument.body.appendChild(s);
  }

  if (iframe.contentWindow) {
    // Enabling this flag will prevent parent website's FS from recording our widget, but it also
    // prevents our FS from recording sessions
    // https://github.com/SimplrSupport/simplr-chat-web/pull/294#discussion_r1084369787
    // iframe.contentWindow['_fs_is_outer_script'] = true;

    if (environment.nodeEnv !== 'production') {
      iframe.contentWindow['__REACT_DEVTOOLS_GLOBAL_HOOK__'] = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
    }
  }

  return iframe;
};

const init = async () => {
  await waitForPage();
  console.log('Initializing simplr chat...');
  renderIframe();
};

init();
